// 字体加载检测工具
class FontLoader {
  constructor() {
    this.isMobile = this.checkMobile();
    this.isLowPerformance = this.checkLowPerformance();
    this.isSafari = this.checkSafari();
    this.fontsLoaded = false;
  }

  // 检测是否为移动设备
  checkMobile() {
    return window.innerWidth <= 767 || 
           /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  // 检测是否为Safari浏览器
  checkSafari() {
    return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
  }

  // 检测设备性能
  checkLowPerformance() {
    // 检测网络连接
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (connection) {
      return connection.effectiveType === 'slow-2g' || 
             connection.effectiveType === '2g' || 
             connection.effectiveType === '3g';
    }
    
    // 检测设备内存
    if (navigator.deviceMemory) {
      return navigator.deviceMemory < 4; // 小于4GB内存
    }
    
    return false;
  }

  // 检测字体是否加载完成
  checkFontLoaded(fontFamily) {
    return new Promise((resolve) => {
      if (document.fonts && document.fonts.check) {
        // 现代浏览器使用Font Loading API
        const checkFont = () => {
          const isLoaded = document.fonts.check(`12px "${fontFamily}"`);
          if (isLoaded) {
            resolve(true);
          } else {
            // 延迟重试
            setTimeout(() => {
              const finalCheck = document.fonts.check(`12px "${fontFamily}"`);
              resolve(finalCheck);
            }, 1000);
          }
        };
        
        // 立即检测
        checkFont();
      } else {
        // 降级方案：使用Canvas检测（延迟执行）
        setTimeout(() => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const testString = '测试文字';
          
          // 设置测试字体
          ctx.font = `12px "${fontFamily}"`;
          const width1 = ctx.measureText(testString).width;
          
          // 设置备用字体
          ctx.font = '12px Arial';
          const width2 = ctx.measureText(testString).width;
          
          // 如果宽度不同，说明字体已加载
          resolve(width1 !== width2);
        }, 1000);
      }
    });
  }

  // 是否应该加载自定义字体 - 修改为始终加载阿里普惠字体
  shouldLoadCustomFont() {
    // 所有设备都使用阿里普惠字体
    return true;
  }

  // 应用字体策略 - 修改为始终启用阿里普惠字体
  applyFontStrategy() {
    // 始终启用阿里普惠字体
    this.enableCustomFonts();
    console.log('所有设备：统一使用阿里普惠字体');
  }

  // 禁用自定义字体 - 保留方法但不使用
  disableCustomFonts() {
    // 不再禁用阿里普惠字体
    console.log('已移除字体禁用功能，统一使用阿里普惠字体');
  }

  // 启用自定义字体
  enableCustomFonts() {
    // 移除禁用类
    document.documentElement.classList.remove('no-custom-fonts');
    console.log('已启用阿里普惠字体');
  }

  // 预加载字体
  preloadFonts() {
    // 字体预加载由CSS的@font-face处理，这里不需要额外的预加载
    if (this.shouldLoadCustomFont()) {
      console.log('字体预加载：由CSS @font-face处理');
    }
  }

  // 等待字体加载完成
  async waitForFonts() {
    if (this.shouldLoadCustomFont()) {
      try {
        const fontLoaded = await this.checkFontLoaded('Alibaba PuHuiTi');
        this.fontsLoaded = fontLoaded;
        console.log('阿里普惠字体加载状态:', fontLoaded ? '✅ 成功' : '⚠️ 检测中...');
        // 如果首次检测失败，延迟再次检测
        if (!fontLoaded) {
          setTimeout(() => {
            const recheckResult = document.fonts.check(`12px "Alibaba PuHuiTi"`);
            console.log('阿里普惠字体二次检测:', recheckResult ? '✅ 成功加载' : '❌ 确实失败');
          }, 3000);
        }
        return fontLoaded;
      } catch (error) {
        console.warn('字体加载检测失败:', error);
        return false;
      }
    }
    return true;
  }

  // 初始化
  async init() {
    // 预加载字体
    this.preloadFonts();
    
    // 应用字体策略
    this.applyFontStrategy();
    
    // 等待字体加载
    await this.waitForFonts();
    
    // 监听窗口大小变化
    window.addEventListener('resize', () => {
      // const wasMobile = this.isMobile;
      this.isMobile = this.checkMobile();
      
      // 不再根据设备类型改变字体策略
      console.log('窗口大小变化，保持阿里普惠字体');
    });
  }
}

// 导出实例
export const fontLoader = new FontLoader();

// 默认导出
export default FontLoader; 